import { render, staticRenderFns } from "./DokumenPendukung.vue?vue&type=template&id=954da64a&"
import script from "./DokumenPendukung.vue?vue&type=script&lang=js&"
export * from "./DokumenPendukung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports